App.service('$api', (authServiceHelpers, $http, SERVER_BASE_URL) => {
  // $http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
  var fn = (method, url, params, data, opts) => {
      opts = opts || {}
      var cookies = authServiceHelpers.getUserAuthorization()
      var subdomain = authServiceHelpers.getUserSubdomain()
      if(typeof subdomain == 'undefined'){
        var myurl = `${SERVER_BASE_URL}${url}`
      } else {
        var myurl = `${SERVER_BASE_URL}${url}?subdomain=${subdomain}`
      }
      headers = opts.headers || {}
      headers['Authorization'] = authServiceHelpers.getUserAuthorizationHeader()
      if(method == 'PUT' || method == 'POST' ){
        headers["Content-Type"] = "application/json;charset=UTF-8"
        opts.transformRequest = opts.transformRequest || angular.toJson
      }

      // TODO remove after ImpersonationSession retirement
      var impersonationSessionId = authServiceHelpers.impersonationSessionId()
      if(typeof impersonationSessionId != 'undefined'){
        headers["Nex-ImpersonationSessionId"] = impersonationSessionId
      }

      var req = {
        method: method,
        url: myurl,
        headers: headers,
        data: data,
        params: params,
        paramSerializer: opts.paramSerializer || '$httpParamSerializerJQLike',
        response_type: "json"
      }
      if(opts.transformRequest){
        req.transformRequest = opts.transformRequest
      }
      // lg("ran http",method,url,params)
      return $http(req)
  }
  return fn
})
